import { Link } from 'gatsby';

export const getFooterLinkProps = link => {
  switch (link.href[0]) {
    case '/':
      return {
        to: link.href,
        tag: Link,
      };
    case undefined:
      return {
        to: '',
        tag: 'p',
      };
    default:
      return {
        href: link.href,
        tag: 'a',
      };
  }
};
